// depend error can have other depend errors,
// so we need to go all the way to the deepest original_error
export const get_root_error = (error) => {
  let original_error = error
  while ('original_error' in original_error) {
    original_error = original_error.original_error
  }
  return original_error
}
